<template>
  <div class="contact">
    <div class="header-banner">
      <Header class="home-header" :isLogin="true" />
    </div>
    <div class="contact-banner"></div>
    <div class="main-wrapper padding-top-xl  padding-bottom-xl bg-white top-boarder margin-top">
      <div class="flex justify-center">
        <div class="contact-type">
          <div class="margin-left-xl contact-line1">客服热线</div>
          <div class="margin-left-xl contact-line2">186 0002 7596</div>
          <div class="margin-left-xl contact-line3">24小时服务热线</div>
        </div>
        <div class="contact-type">
          <div class="margin-left-xl contact-line1">客服邮箱</div>
          <div class="margin-left-xl contact-line2">kefu@sciia.org</div>
        </div>
      </div>
      <div class="flex justify-center">
        <div class="contact-type">
          <div class="margin-left-xl contact-line1">商务合作</div>
          <div class="margin-left-xl contact-line2">186 0197 8758</div>
        </div>
        <div class="contact-type">
          <div class="margin-left-xl contact-line1">传真</div>
          <div class="margin-left-xl contact-line2">+86-10-56407186</div>
        </div>
      </div>
    </div>
    <Footer :isLogin="true" />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue';
  import Footer from '@/components/Footer.vue';
  export default {
    name: 'About',
    components: {
      Header,
      Footer,
    }
  }
</script>

<style scoped>
  @import url(../mainui.css);

  .main-wrapper {
    min-height: 3.25rem;
  }

  .top-boarder {
    border-top: 1px solid rgba(67, 67, 67, .3);
  }

  .contact-banner {
    background-image: url('http://img.yunsmartcity.com/kefu/lianxi.png');
    width: 100vw;
    height: calc(100vw * 0.2);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
  }

  .contact-type{
    width: 30vw;
    height: calc(30vw * 0.3);
    background: #F5F7FA;
    border: 1px solid #E9E9E9;
    margin: 24px 24px;
  }
  .contact-line1 {
    margin-top: 15px;
    font-size: 23px;
    font-weight: 400;
    color: #000000;
    line-height: 23px;
  }

  .contact-line2 {
    font-size: 31px;
    font-weight: 400;
    color: #FF8D08;
    line-height: 47px;
  }

  .contact-line3 {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    line-height: 21px;
  }
</style>
